import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import CustomerStory from 'marketing-website/components/modules/CustomerStory';
import customerStoriesItems from 'marketing-website/configs/customerStoriesItems.js';

export default function Stories() {
  return (
    <PageWrap size="l">
      <Spacing size="l" sizeM="xl" position="topBottom" type="margin">
        <Grid columns={6} size="l" sizeM="xl" alignItems="center">
          {customerStoriesItems.map(item => (
            <GridItem
              key={item.id}
              columnSpan={6}
              columnSpanS={3}
              columnSpanM={2}
            >
              <CustomerStory
                image={item.image}
                logo={item.logo}
                title={item.title}
                url={item.url}
              />
            </GridItem>
          ))}
        </Grid>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/customer-stories/_Stories.js